import type { TranslationKey } from './shared/types';

export function translationKey(key: string): TranslationKey {
	return key as unknown as TranslationKey;
}
